export function shoppingCartEvents() {
	const shoppingCart = document.querySelector("#open-shopping-cart");
	if (!shoppingCart) return;
	async function firstClick(e) {
		shoppingCart.removeEventListener("click", firstClick);
		try {
			const { initShoppingCart } = await import("./shopping-cart.js");
			const openShoppingCart = initShoppingCart();
			openShoppingCart(e);
		} catch (err) {
			console.error("Failed to load module:", err);
		}
	}
	shoppingCart.addEventListener("click", firstClick);
}
